import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import ChecklistItemStatus from "models/checklist/checklist-item/checklist-item-status";
import styled from "styled-components";

interface StatusValueProps {
  status: ChecklistItemStatus;
  isInfo: boolean;
}

const StatusValue = styled(MicroHeader)<StatusValueProps>`
  color: ${({ status, isInfo, theme }) => {
    if (isInfo && status !== ChecklistItemStatus.Resolved) {
      return theme.colors.additional1;
    }
    switch (status) {
      case ChecklistItemStatus.Resolved:
        return theme.colors.confirmation;
      case ChecklistItemStatus.NotYetResolved:
      case ChecklistItemStatus.VerificationRequired:
      default:
        return theme.colors.notResolvedChecklistStatus;
    }
  }};
`;

export default StatusValue;
